export default {
    matchBySearchQuery: (object: object, searchQuery: string, excludedProperties: string[] = []) => {
        excludedProperties = excludedProperties || [];

        if (!searchQuery || searchQuery.length === 0) {
            return true;
        }

        const objectAsText = Object.keys(object)
            .reduce(function (concatenated, item) {
                if (typeof object[item] !== "string") {
                    return concatenated + "";
                }

                if (excludedProperties.indexOf(item) >= 0) {
                    return concatenated + "";
                }

                return concatenated + object[item] + " ";
            }, "")
            .toLowerCase();

        const keywords = searchQuery.toLowerCase().split(" ");
        let result = true;

        keywords.forEach(function (keyword) {
            if (objectAsText.indexOf(keyword) === -1) {
                result = false;
            }
        });
        return result;
    },
    matchString(searchQuery: string | undefined | null, objectAsText: string): boolean {
        if (!searchQuery || searchQuery.length === 0) {
            return true;
        }

        const keywords = searchQuery.toLowerCase().split(" ");
        let result = true;

        objectAsText = objectAsText.toLowerCase();

        keywords.forEach(function (keyword) {
            if (objectAsText.indexOf(keyword) === -1) {
                result = false;
            }
        });
        return result;
    },
};
